module.exports = __webpack_public_path__ + "img/dm.5113f62.svg";